import React from 'react';
import PropTypes from 'prop-types';
import {Stack} from "@mui/material";

import Badge from "components/Badge";
import {greyishBlue50, greyishBlue100, greyishBlue700} from "assets/jss/main";

VariantChips.propTypes = {
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const MAX_CHIPS = 12;

const chipColors = {backgroundColor: greyishBlue50, borderColor: greyishBlue100, labelColor: greyishBlue700};

function VariantChips({labels}) {
    return (
        <Stack direction="row" flexWrap="wrap" gap="4px" sx={{width: '192px'}}>
            {labels.slice(0, MAX_CHIPS).map((label, index) => (
                <Badge key={`${label}-${index}`} border {...chipColors}>{label}</Badge>
            ))}
            {labels.length > MAX_CHIPS && <Badge border {...chipColors}>{`+${labels.length - MAX_CHIPS}`}</Badge>}
        </Stack>
    );
}

export default VariantChips;
